__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@oneaudi/fa-app-store-api-docs";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@audi/audi-ui-design-tokens", "3.16.0", () => (__webpack_require__.e(224).then(() => (() => (__webpack_require__(8224))))));
			register("@audi/audi-ui-react", "3.16.0", () => (Promise.all([__webpack_require__.e(463), __webpack_require__.e(526), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(259), __webpack_require__.e(263)]).then(() => (() => (__webpack_require__(9526))))));
			register("@oneaudi/oneaudi-os-authentication", "8.1.2", () => (Promise.all([__webpack_require__.e(463), __webpack_require__.e(939), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(259), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(2939))))));
			register("mobx", "6.15.0", () => (__webpack_require__.e(813).then(() => (() => (__webpack_require__(7813))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(961))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("redoc", "2.5.2", () => (Promise.all([__webpack_require__.e(794), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(259), __webpack_require__.e(211), __webpack_require__.e(585)]).then(() => (() => (__webpack_require__(8794))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(568), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(2568))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};